<template>
    <div>
        <div id="header-container" class="pl-5">
            <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header">
            <div class="pt-4 text-white">
                <h3 class="text-white">{{ $t('Withdrawal') }}</h3>
                <span class="fz-16 fw-400">{{ $t('View your withdrawal report here') }}</span>
            </div>
        </div>

        <b-container fluid class="mt-0 pb-5">
            <b-row class="pt-3">
                <b-col cols="12">
                    <div id="top-container" class="mb-4 position-relative">
                        <img :src="`${publicPath}/img/gep/withdrawal.svg`" class="w-100" />
                        <div class="position-absolute">
                            <h4 class="mb-3" v-html="$t('Withdraw Funds Easily<br>and Safely Anytime')"></h4>
                            <button class="btn btn-primary" @click="withdrawNow">{{ $t('Withdraw Now') }}</button>
                        </div>
                    </div>
                    <div id="body-container" class="mt-0">
                        <div class="d-block d-md-flex align-items-center mb-2 p-2">
                            <h5 class="fz-22 fw-700">{{ $t('Withdrawal History') }}</h5>
                        </div>
                        <RemittanceHistory></RemittanceHistory>
                    </div>
                </b-col>
            </b-row>
        </b-container>

        <LoaderComponent v-if="isLoading"></LoaderComponent>
    </div>
</template>
<script>

import LoaderComponent from "@/components/LoaderComponent";
// import WidhdrawalHistory from "@/components/WidhdrawalHistory";
import RemittanceHistory from "@/components/RemittanceHistory";
import CreateAccount from "@/services/CreateAccount";
import Common from "@/services/Common";

export default {
    name: 'withdrawal',
    data() {
        return {
            publicPath: process.env.BASE_URL != '/' ? process.env.BASE_URL : '',
            isLoading: false,
            accountslist: '',
            tabIndex: -1,
            selected: {}
        }
    },
    components: {
        LoaderComponent,
        // WidhdrawalHistory,
        RemittanceHistory
    },
    methods: {
        withdrawNow() {
            this.isLoading = true;
            Common.profile().then(response => {
                this.isLoading = false;
                if (response.status == 200 && response.data.success) {
                    const profile = response.data.data;
                    if (profile.security_code == null) {
                        this.$router.push({
                            path: '/set-payment-password'
                        });
                    }
                    else {
                        this.$router.push({
                            path: '/different-name'
                        });
                    }
                }
            });
        },
        addBeneficiary() {
            this.$router.push({
                path: '/add-beneficiary'
            });
        },
        checkError(err) {
            try {
                this.isLoading = false;
                const response = err.response;
                if (response.status == 400) {
                    console.log(response.data);
                    if (typeof response.data.message === 'string') {
                        this.$notify({
                            type: 'warn',
                            text: response.data.message
                        });
                    }
                    else {
                        if (response.data.message['errorMsg']) {
                            this.$notify({
                                type: 'warn',
                                text: response.data.message['errorMsg']
                            });
                        }
                        else {
                            let ret = [];
                            Object.keys(response.data.message).forEach((key) => {
                                ret.push(response.data.message[key][0]);
                            });

                            this.$notify({
                                type: 'warn',
                                html: ret.join("<br>")
                            });
                        }
                    }
                }
                else if (response.status == 401 && response.data.name == "Unauthorized") {
                    localStorage.removeItem("token");
                    localStorage.removeItem("member");
                    localStorage.removeItem("isFirstTime");
                    this.$router.push({
                        path: '/login',
                    });
                }
                else {
                    if (localStorage.getItem("token")) {
                        var msg = (response.data) ? response.data.message : err.message;
                        this.$notify({
                            type: 'warn',
                            text: msg
                        })
                    }
                }
            } catch (e) {
                console.log(err);
            }
        }
    },
    mounted() {
        let self = this;
        this.$nextTick(() => {
            CreateAccount.list().then((response) => {
                if (response.status == 200) {
                    let account = response.data.data;
                    this.accountslist = response.data.data[0].information.name;
                    if (account) {
                        account.forEach(element => {
                            if (element.status == 2) {
                                self.selected = element;
                            }
                        });
                    }
                }
            });
        });
    }
};
</script>

<style>
.block-list-history {
    background-color: #F8F9FA;
    padding: 20px 15px !important;
    border-radius: 8px;
}
</style>
